import './article-description.scss';

/**
 * version    1.0
 * class      <type> (article description)
 * classdesc
 */
export class ArticleDescription {}
